import { render, staticRenderFns } from "./VideojsTest.vue?vue&type=template&id=75044138&scoped=true&"
import script from "./VideojsTest.vue?vue&type=script&lang=js&"
export * from "./VideojsTest.vue?vue&type=script&lang=js&"
import style0 from "./VideojsTest.vue?vue&type=style&index=0&id=75044138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75044138",
  null
  
)

export default component.exports